<!-- <div class="upload">
    
    <div class="card-top card-head">
        <h3>Bulk Upload</h3>
        <p>Add multiple vehicles using excel/csv template</p>
    </div>
    <div class="btn-row">
        <a (click)="downloadTemplate()">
            <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin"></fa-icon>
            DOWNLOAD TEMPLATE
        </a>
        <a (click)="fileInput.click()">
            <fa-icon [icon]="['fas', 'upload']" class="fa-solid"></fa-icon>
            UPLOAD FILE
            <input
            #fileInput
            type="file"
            (change)="uploadFile($event)"
            name="file"
            style="display: none;"
        />
        </a>
        
        <a (click)="guidelines()">
            <fa-icon [icon]="['fas', 'circle-exclamation']" class="fa-thin"></fa-icon>
            SAMPLE GUIDELINES
        </a>
    </div>

  </div> -->

<div class="vehicle-wrapper">
    
  <div class="top-header">
      <h3>Bulk Upload</h3>
      <p>Add multiple vehicles using excel/csv template</p>
  </div>
  <div class="btn-row">
      <a (click)="downloadTemplate()">
          <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin"></fa-icon>
          DOWNLOAD TEMPLATE
      </a>
      <a (click)="fileInput.click()">
          <fa-icon [icon]="['fas', 'upload']" class="fa-solid"></fa-icon>
          UPLOAD FILE
          <input
          #fileInput
          type="file"
          (change)="uploadFile($event)"
          name="file"
          style="display: none;"
      />
      </a>
      
      <a (click)="guidelines()">
          <fa-icon [icon]="['fas', 'circle-exclamation']" class="fa-thin"></fa-icon>
          SAMPLE GUIDELINES
      </a>
  </div>

  <app-bulk-import-result
          *ngIf="bulkImportResult"
          [totalImported]="bulkImportResult.totalImported"
          [totalFailed]="bulkImportResult.totalFailed"
          [errors]="bulkImportResult.errors"
          [failedRowsCsvBase64]="bulkImportResult.failedRowsCsvBase64"
          [failedRowsFilename]="bulkImportResult.failedRowsFilename">
  </app-bulk-import-result>

</div>


<!-- modal -->
<div *ngIf="showModal" class="confirmation-modal">
    <div class="modal-content">
      <div class="close">
        <span  (click)="closeModal()">
          <fa-icon [icon]="['fas', 'circle-xmark']" class="fa-thin"></fa-icon>
        </span>
      </div>
      <div class="popup-content">
        <div *ngFor="let guideline of sampleGuidelines | keyvalue: originalOrder" class="popup-item">
        
          <span class="icon">➜</span>
          <div>
            <strong>{{guideline.key}}</strong>
            <p>{{ guideline.value }}</p>
          </div>
        </div>
      </div>
</div>
